import { scApi } from './shared';

/** Hand-authored Google Search endpoint copy and examples. Upstream is a search
 *  provider kept internal; AnyAPI is the presented provider (see CLAUDE.md). */
export const GOOGLE = scApi({
  id: 'google',
  name: 'Google',
  category: 'Search',
  color: 'var(--c-blue)',
  blurb:
    'Real-time Google web search results as clean JSON: send a query, get back the organic results with titles, links and snippets. One key, one wallet, billed per request in real dollars.',
  endpoints: {
    search: {
      action: 'Web search',
      description: 'Run a Google web search and get the organic results: title, link, snippet and rank position.',
      input: { query: 'best running shoes 2026', gl: 'us' },
      sample: {
        query: 'best running shoes 2026',
        results: [
          {
            title: 'The 12 Best Running Shoes of 2026, Tested by Runners',
            link: 'https://www.example.com/best-running-shoes',
            snippet: 'We logged hundreds of miles in this year’s top trainers to find the best running shoes for every type of runner and budget.',
            position: 1,
          },
        ],
      },
    },
  },
});
